<template>
    <form-row title="Policy Number" :no_border="true" class="mt-8">
        <input-text
            class="flex-1"
            :value="insurance.policy_number"
            name="policy_number"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        insurance: {},
        read_only: { default: false },
    },
}
</script>
